module.exports = __webpack_public_path__ + "img/CW.7dbea206.svg";